import { component } from 'picoapp'
import sal from 'sal.js'

export default component((node, ctx) => {
  //console.log('product-item mounted')
  const itemHover = node.querySelector('.js-product-item-hover')
  const itemReveal = node.querySelector('.js-product-item-reveal')
  //const itemBackgroundColor = itemHover.dataset.backgroundColor;
  //const itemBackground = node.querySelector('.js-product-item-background')
  sal({
    threshold: .1,
  });
  
  const toggleBackground = () => {
    
    if(itemReveal){
      //console.log('reveal')
      node.classList.toggle('bg-visible')
    }
    
    
    /*
    setTimeout(() => {
      node.classList.remove('is-active')
      //app.hydrate({curtainOpen: false})
      ctx.emit('curtain:closed', state => {
        return {
          curtainOpen: false
        }
      })
    }, 750)
    */
  }
  const addBodyColor = () => {
    document.querySelector('body').setAttribute("style", "background-color:"+ itemBackgroundColor + ";")
  }

  const removeBodyColor = () => {
    document.querySelector('body').setAttribute("style", "background-color: #fff;")
  }

  itemHover.addEventListener('mouseenter', toggleBackground)
  itemHover.addEventListener('mouseleave', toggleBackground)
  //itemHover.addEventListener('mouseenter', addBodyColor)
  //itemHover.addEventListener('mouseleave', removeBodyColor)

  return node => {
    //console.log('product-item unmounted')
  }
})
